import React, { useEffect } from 'react';
import useFormVisibilityStore from './FormConditionStores/useFormVisibilityStore';
import ItemStatementCondition from './FormConditionComponents/ItemStatementVisibility';

function FormConditional({ visibility, availablePlaceholders }) {
  useEffect(() => {
    if (visibility && visibility.Statement) {
      useFormVisibilityStore.getState().setStatement(visibility);
      useFormVisibilityStore.getState().setFormConditional(visibility);
    } else {
      useFormVisibilityStore.getState().initialiseEmpty();
    }
  }, []);

  const { Condition } = useFormVisibilityStore((s) => s.Statement.Statement.content);
  const AnswerList = useFormVisibilityStore((s) => s.AnswerList);

  return (
    <div
      style={{
        boxShadow: '0px 2px 4px var(--mui-palette-action-focus)',
        padding: '15px 15px 30px',
        margin: '15px 0',
      }}
    >
      {Condition &&
        Condition.map((condition, index) => (
          <ItemStatementCondition
            condition={condition}
            indexStatement={index}
            key={index}
            AnswerList={AnswerList[index]}
            availablePlaceholders={availablePlaceholders}
          />
        ))}
    </div>
  );
}
export default FormConditional;
